/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Audiences_EyebrowInputs */

const en_directory_taxonomy_audiences_eyebrow = /** @type {(inputs: Directory_Taxonomy_Audiences_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by audience`)
};

const zh_directory_taxonomy_audiences_eyebrow = /** @type {(inputs: Directory_Taxonomy_Audiences_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按适用人群浏览`)
};

/**
* | output |
* | --- |
* | "Browse by audience" |
*
* @param {Directory_Taxonomy_Audiences_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_audiences_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Audiences_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Audiences_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_audiences_eyebrow(inputs)
	return zh_directory_taxonomy_audiences_eyebrow(inputs)
});
export { directory_taxonomy_audiences_eyebrow as "directory.taxonomy.audiences.eyebrow" }